import { DELETE_LOCAL_SALON_TAG } from 'actions/tags/deleteLocalSalonTag.types';
import { DELETE_SALON_TAG_FAILURE, DELETE_SALON_TAG_REQUEST, DELETE_SALON_TAG_SUCCESS } from 'actions/tags/deleteSalonTag.types';
import { FETCH_SALON_TAGS_LIST_FAILURE, FETCH_SALON_TAGS_LIST_REQUEST, FETCH_SALON_TAGS_LIST_SUCCESS } from 'actions/tags/fetchSalonTagsList.types';
import { SAVE_SALON_TAG_FAILURE, SAVE_SALON_TAG_REQUEST, SAVE_SALON_TAG_SUCCESS } from 'actions/tags/saveSalonTag.types';
import { UPDATE_CLIENT_TAGS_LIST } from 'actions/tags/updateClientTagsList.types';
import removeById from 'utils/arrays/removeById.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import asObject from 'utils/objects/asObject.util';

const DEFAULT = Object.freeze({
  clientTags: [],
  isFetching: false,
  errorMessage: '',
  error: '',
});

const reduceRequest = (state, { isFetching }) => ({ ...state, isFetching });
const reduceFailure = (state, { errorMessage, error, isFetching }) => ({
  ...state,
  errorMessage,
  error,
  isFetching,
});

// this removes the switch/case noise
const MAP = Object.freeze({
  [DELETE_LOCAL_SALON_TAG]: (state, { data: { tagId } }) => {
    const { clientTags } = state;
    return {
      ...state,
      clientTags: removeById(tagId, clientTags),
    };
  },
  [DELETE_SALON_TAG_REQUEST]: reduceRequest,
  [DELETE_SALON_TAG_SUCCESS]: (state, { isFetching, params: { tagId } }) => {
    const { clientTags } = state;
    return {
      ...state,
      clientTags: removeById(tagId, clientTags),
      isFetching,
    };
  },
  [DELETE_SALON_TAG_FAILURE]: reduceFailure,
  [FETCH_SALON_TAGS_LIST_REQUEST]: reduceRequest,
  [FETCH_SALON_TAGS_LIST_SUCCESS]: (state, { response, isFetching }) => ({
    ...state,
    clientTags: [...response],
    isFetching,
  }),
  [FETCH_SALON_TAGS_LIST_FAILURE]: reduceFailure,
  [SAVE_SALON_TAG_REQUEST]: reduceRequest,
  [SAVE_SALON_TAG_SUCCESS]: (state, { response, params: { savedTagId }, isFetching }) => {
    const { clientTags } = state;
    const newClientTags = clientTags.map((tag) => (tag.id === savedTagId ? response : tag));
    return { ...state, clientTags: newClientTags, isFetching };
  },
  [SAVE_SALON_TAG_FAILURE]: reduceFailure,
  [UPDATE_CLIENT_TAGS_LIST]: (state, { data }) => ({ ...state, clientTags: data }),
});

// this top level reducer serves to set up defaults for the state, if needed, as deep as necessary
// determine the action data from variety of different action shapes
// and delegate to the specific handlers per the action type
const customClientTagsReducer = (state, action) => (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

export default customClientTagsReducer;
